import TRAILER_6x12SA from "../static/desktop/6x12_SA.webp";
import TRAILER_6x12TA from "../static/desktop/6x12_TA.webp";
import TRAILER_7x14TA from "../static/desktop/7x14_TA.webp";


const trailerData = [
    {
        title: "6x12 Single-Axle Enclosed Cargo Trailer",
        image: TRAILER_6x12SA,
        description: "A standard size cargo trailer for light to moderate loads (< 3000 lbs. GVWR). Perfect for personal use such as moving household items, furniture, yard equipment, or lighter cargo. Easy to tow!",
        price: "$3,195",
        specs: ["Single Axle", "Ramp Door", "V-Nose Front", "Aluminum"],
        badge: "Special Offer!",
        badge2: "Best Seller",
        contactHint: "I am interested in the 6x12 Single-Axle Enclosed Cargo Trailer listed for $3,195 on the front page of the website."
    },
    {
        title: "6x12 Tandem-Axle Enclosed Cargo Trailer",
        image: TRAILER_6x12TA,
        description: "Like the Single-Axle but rated up to 5-7000 lbs. GVWR (depending on upgrades). This is the perfect trailer for heavier loads and long-distance hauling where the extra axle provides better load distribution, smoother rides, and tire redundancy.",
        price: "$4,395",
        specs: ["Tandem Axle", "Ramp Door", "V-Nose Front", "Aluminum/Polycore"],
        badge: "Best Seller",
        contactHint: "I am interested in the 6x12 Tandem-Axle Enclosed Cargo Trailer listed for $4,395 on the front page of the website."
    },
    {
        title: "7x14 Tandem-Axle Enclosed Cargo Trailer",
        image: TRAILER_7x14TA,
        description: "Popular for hauling equipment, tools, and other heavier cargo with minimal sway or bounce. Durable and maneuverable, this trailer is the perfect option for contractors and serious DIYers alike. Unmatched in long-term value.",
        price: "$4,995",
        specs: ["Tandem Axle", "Ramp Door", "V-Nose Front", "Aluminum/Polycore"],
        badge: "Best Seller",
        contactHint: "I am interested in the 7x14 Tandem-Axle Enclosed Cargo Trailer listed for $4,995 on the front page of the website."
    }
]


export default trailerData;